import lockerJavelin from "./stage3/jevlin.png";
import lockerBoxing from "./stage3/boxing.png";
import lockerChess from "./stage3/chess.png";
import lockerLift from "./stage3/belt.png";
import lockerShoot from "./stage3/shooting.png";

/** Points written to DB `stage3` on successful restore. */
export const LOCKER_ARCHIVE_POINTS = 100;

/** Puzzle 4 hotspot unlocked after Locker Archive (Museum Archive) success. */
export const LOCKER_ARCHIVE_UNLOCKS = "newspaper";

export const LOCKERS = [
  {
    id: "locker_1",
    number: 1,
    athleteId: "neeraj_chopra",
    image: lockerJavelin,
    clues: [
      "Javelin",
      "Running Spikes",
      "Olympic Gold Medal Replica",
      "Training Bib",
    ],
  },
  {
    id: "locker_2",
    number: 2,
    athleteId: "mary_kom",
    image: lockerBoxing,
    clues: [
      "Boxing Gloves",
      "Hand Wraps",
      "Red Headgear",
      "Championship Belt",
    ],
  },
  {
    id: "locker_3",
    number: 3,
    athleteId: "viswanathan_anand",
    image: lockerChess,
    clues: [
      "Chess Board",
      "Chess Clock",
      "Scoresheet",
      "Knight Keychain",
    ],
  },
  {
    id: "locker_4",
    number: 4,
    athleteId: "mirabai_chanu",
    image: lockerLift,
    clues: [
      "Weightlifting Belt",
      "Lifting Shoes",
      "Chalk Bag",
      "Barbell Clip",
    ],
  },
  {
    id: "locker_5",
    number: 5,
    athleteId: "abhinav_bindra",
    image: lockerShoot,
    clues: [
      "Rifle",
      "Shooting Glasses",
      "Ear Protection",
      "Target Sheet",
    ],
  },
];

/** Correct athletes + distractors for the name pool. */
export const ATHLETE_NAMES = [
  { id: "neeraj_chopra", name: "Neeraj Chopra", sport: "Athletics (Javelin Throw)" },
  { id: "mary_kom", name: "Mary Kom", sport: "Boxing" },
  { id: "viswanathan_anand", name: "Viswanathan Anand", sport: "Chess" },
  { id: "mirabai_chanu", name: "Mirabai Chanu", sport: "Weightlifting" },
  { id: "abhinav_bindra", name: "Abhinav Bindra", sport: "Shooting (10m Air Rifle)" },
  { id: "pv_sindhu", name: "PV Sindhu", sport: "Badminton" },
  { id: "sunil_chhetri", name: "Sunil Chhetri", sport: "Football" },
  { id: "leander_paes", name: "Leander Paes", sport: "Tennis" },
  { id: "dipa_karmakar", name: "Dipa Karmakar", sport: "Artistic Gymnastics" },
  { id: "bajrang_punia", name: "Bajrang Punia", sport: "Wrestling" },
  { id: "harmanpreet_kaur", name: "Harmanpreet Kaur", sport: "Cricket" },
  { id: "pullela_gopichand", name: "Pullela Gopichand", sport: "Badminton" },
  { id: "milkha_singh", name: "Milkha Singh", sport: "Athletics (Track & Field)" },
  { id: "kapil_dev", name: "Kapil Dev", sport: "Cricket" },
  { id: "rani_rampal", name: "Rani Rampal", sport: "Hockey" },
];

export function shuffleArray(list) {
  const next = [...list];
  for (let i = next.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [next[i], next[j]] = [next[j], next[i]];
  }
  return next;
}

/**
 * placements: lockerId -> athleteId|null
 * @returns {{ ok: boolean, wrongLockerIds: string[], missingLockerIds: string[], correctCount: number }}
 */
export function validateLockerPlacements(placements, lockers = LOCKERS) {
  const wrongLockerIds = [];
  const missingLockerIds = [];
  let correctCount = 0;

  lockers.forEach((locker) => {
    const assigned = placements[locker.id];
    if (assigned == null || assigned === "") {
      missingLockerIds.push(locker.id);
      return;
    }
    if (assigned === locker.athleteId) {
      correctCount += 1;
    } else {
      wrongLockerIds.push(locker.id);
    }
  });

  return {
    ok: wrongLockerIds.length === 0 && missingLockerIds.length === 0,
    wrongLockerIds,
    missingLockerIds,
    correctCount,
  };
}

/** Assign athlete to locker; swap with origin when dropping onto an occupied slot. */
export function assignNameToLocker(
  placements,
  lockerId,
  athleteId,
  originLocker = null
) {
  const next = { ...placements };
  const displaced =
    next[lockerId] != null && next[lockerId] !== athleteId
      ? next[lockerId]
      : null;

  Object.keys(next).forEach((id) => {
    if (next[id] === athleteId) next[id] = null;
  });

  if (displaced && originLocker && originLocker !== lockerId) {
    next[originLocker] = displaced;
  }

  next[lockerId] = athleteId;
  return next;
}

export function clearLockerAssignment(placements, lockerId) {
  return { ...placements, [lockerId]: null };
}

export function unassignedAthleteIds(placements, athletes = ATHLETE_NAMES) {
  const used = new Set(
    Object.values(placements).filter((id) => id != null && id !== "")
  );
  return athletes.filter((a) => !used.has(a.id)).map((a) => a.id);
}
